import { QuestionMarkCircle } from '@crehana/compass.icons.fill/v2/question-mark-circle';
import { Calendar } from '@crehana/compass.icons.outline/v2/calendar';
import { TooltipWrapper } from '@crehana/compass.ui/tooltip';

import { useHomeTranslations } from '../../../hooks/use-home-translations';
import { formatNextPaymentDate } from '../utils/format-payroll-date';

type NextPaymentDateProps = {
  nextPaymentDate: string;
  isEstimated?: boolean;
};

export function NextPaymentDate({
  nextPaymentDate,
  isEstimated = true,
}: NextPaymentDateProps) {
  const { t, languageCode } = useHomeTranslations();
  const formattedDate = formatNextPaymentDate(nextPaymentDate, languageCode);

  return (
    <div className="tw-cds-bg-brand tw-flex tw-items-center tw-cds-gap-space-04 tw-cds-p-space-04 tw-border tw-border-solid tw-cds-radius-s tw-cds-border-brand-strong">
      <Calendar
        size={24}
        className="tw-text-[var(--cds-icon-bg-default-02)]"
        aria-hidden
      />
      <div className="tw-flex tw-flex-col tw-cds-gap-title-s">
        <div className="tw-flex tw-items-center tw-cds-gap-space-02">
          <span className="tw-cds-font-subtitle-01 tw-cds-text-brand tw-font-semibold">
            {t('PAYROLL_NEXT_PAYMENT_LABEL')}
          </span>
          {isEstimated && (
            <TooltipWrapper
              value={t('PAYROLL_NEXT_PAYMENT_TOOLTIP')}
              side="top"
              align="center"
              delayDuration={100}
              asChild
            >
              <button
                type="button"
                className="tw-inline-flex tw-shrink-0 tw-cds-text-subtle hover:tw-cds-text-primary focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-cds-border-focus tw-rounded-full"
                aria-label={t('PAYROLL_NEXT_PAYMENT_TOOLTIP')}
              >
                <QuestionMarkCircle
                  size={16}
                  className="tw-fill-[var(--cds-icon-bg-default-02)]"
                />
              </button>
            </TooltipWrapper>
          )}
        </div>

        <p className="tw-cds-font-body-03-md tw-cds-text-brand tw-font-semibold">
          {formattedDate}
        </p>
      </div>
    </div>
  );
}
